<template>
  <div id="customerOpinions">
    <div class="top-bg"></div>
    <div class="inner">
      <img src="assets/images/customerOpinions/customerOpinionsIcon.png" alt="">
      <h2 class="section-title blue">{{ t('title') }}</h2>
      <div class="en-customers">
        <div class="en-customers-row" v-for="(row, i) in customers">
          <div class="en-customer" v-for="(customer, j) in row" :class="{ 'active': customer.isActive, 'non-customer': customer.more }">
            <template v-if="customer.more">
              <div class="mock-customer">
                <i class="en en-plus"></i>
              </div>
            </template>
            <template v-else>
              <img :src="customer.graySRC" alt="">
              <div class="en-customer-opinion">
                <img :src="customer.coloredSRC" alt="">
                <p class="opinion-text">{{customer.opinion}}</p>
              </div>
            </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CustomerOpinions',
    data() {
      return {
        // 上一次点击项的索引信息
        lastClick: [-1, -1],
        customers: [
          [{
              graySRC: 'assets/images/customerOpinions/c-nttd-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-nttd-colored.png',
              opinion: `Our company is to use the company's related products of ATL interface, the interface in recent years the use
              of a more stable,the price is right, our company for this product is quite satisfactory.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-nri-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-nri-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-7fs-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-7fs-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-univa-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-univa-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-alipay-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-alipay-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
          ],
          [{
              graySRC: 'assets/images/customerOpinions/c-wechat-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-wechat-colored.png',
              opinion: `Our company is to use the company's related products of ATL interface, the interface in recent years the use
              of a more stable,the price is right, our company for this product is quite satisfactory.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-ms-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-ms-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-narita-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-narita-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-tiat-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-tiat-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-711-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-711-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
          ],
          [{
              graySRC: 'assets/images/customerOpinions/c-ah-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-ah-colored.png',
              opinion: `Our company is to use the company's related products of ATL interface, the interface in recent years the use
              of a more stable,the price is right, our company for this product is quite satisfactory.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-tokyu-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-tokyu-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-odakyu-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-odakyu-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-takeiya-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-takeiya-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-kirindo-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-kirindo-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
          ],
          [{
              graySRC: 'assets/images/customerOpinions/c-harrods-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-harrods-colored.png',
              opinion: `Our company is to use the company's related products of ATL interface, the interface in recent years the use
              of a more stable,the price is right, our company for this product is quite satisfactory.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-selfridges-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-selfridges-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-hnb-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-hnb-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
            {
              graySRC: 'assets/images/customerOpinions/c-jr-gray.png',
              coloredSRC: 'assets/images/customerOpinions/c-jr-colored.png',
              opinion: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.`,
            },
            {
              more: true,
            },
          ]
        ],
      }
    },
    methods: {
      click(customer, row, column) {
        const idx = this.lastClick;
        if (idx[0] >= 0 && idx[1] >= 0) {
          if (!(idx[0] === row && idx[1] === column)) {
            this.customers[idx[0]][idx[1]].isActive = false;
          }
        }
        this.$set(customer, 'isActive', !!!customer.isActive)
        this.lastClick = [row, column];
      },
    },
    locales: {
      en: {
        title: 'CUSTOMERS\' OPINIONS',
      },
      jp: {
        title: '成功事例',
      }
    }
  };
</script>
<style>
  #customerOpinions {
    background-color: #F1F7FC;
    position: relative;
  }
  
  #customerOpinions>.top-bg {
    width: 100%;
    height: 155px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('/assets/images/customerOpinions/topBG.png');
    background-color: #FFF;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
  }
  
  #customerOpinions>.inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    right: 0;
    top: 155px;
  }
  
  #customerOpinions>.inner>h2 {
    color: #5B9BD8;
    margin-bottom: 60px;
  }
  
  .en-customers {
    box-shadow: 0px 10px 18px #E4E4E4;
  }
  
  .en-customers-row {
    display: flex;
    position: relative;
  }
  
  .en-customers-row>.en-customer {
    background-color: #FFF;
    border: 1px solid #E0E0E0;
    width: 100%;
    cursor: pointer;
  }
  
  .en-customers-row>.en-customer:hover {
    box-shadow: 0 5px 20px #B2B2B2;
    z-index: 1;
  }
  
  .en-customers-row>.en-customer.non-customer:hover {
    box-shadow: none;
  }
  
  .en-customers-row>.en-customer.active {
    box-shadow: none;
  }
  
  .en-customers-row>.en-customer img {
    display: block;
  }
  
  .en-customers-row>.en-customer>.en-customer-opinion {
    display: none;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }
  
  .en-customer-opinion>.opinion-text {
    background: #65ABCD;
    color: #FFF;
    margin: 0;
    padding: 30px 100px 30px 50px;
    font-size: 18px;
    line-height: 30px;
    width: 0;
    animation: closeOpinion 0.4s linear;
  }
  
  .en-customers-row>.en-customer:hover>img {
    display: none;
  }
  
  .en-customers-row>.en-customer:hover>.en-customer-opinion {
    display: flex;
  }
  
  .en-customers-row>.en-customer:hover>.en-customer-opinion>.opinion-text {
    display: none;
  }
  
  .en-customers-row>.en-customer.active>.en-customer-opinion {
    position: absolute;
    display: flex;
    box-shadow: 0 5px 20px #B2B2B2;
  }
  
  .en-customers-row>.en-customer.active>.en-customer-opinion>.opinion-text {
    display: block;
    animation: openOpinion 0.4s linear;
    width: 100%;
  }
  
  .mock-customer {
    position: relative;
    width: 100%;
    height: 100%;
  }
  
  .mock-customer>i.en {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #2DAACE;
    font-size: 30px;
  }
  
  .more-customer {
    background: #FFF;
    width: 100%;
    text-align: center;
    color: #1E98D3;
    border: 1px solid #E0E0E0;
  }
  
  .more-customer a {
    cursor: pointer;
  }
  
  @media screen and (max-height: 800px) {
    #customerOpinions>.inner {
      top: 70px;
    }
    #customerOpinions>.inner>h2 {
      margin-bottom: 30px;
    }
    .en-customers-row>.en-customer img {
      width: 182px;
      height: 112px;
    }
    .en-customers-row>.en-customer.active>.en-customer-opinion>.opinion-text {
      padding: 15px 50px 15px 50px;
      font-size: 16px;
      line-height: 28px;
    }
  }
  
  @keyframes openOpinion {
    0% {
      width: 0;
      color: transparent;
    }
    75% {
      width: 100%;
      color: transparent;
    }
    100% {
      width: 100%;
      color: #FFF;
    }
  }
  
  @keyframes closeOpinion {
    0% {
      width: 100%;
      color: #FFF;
    }
    25% {
      width: 100%;
      color: transparent;
    }
    100% {
      width: 0;
      color: transparent;
    }
  }
</style>


// WEBPACK FOOTER //
// CustomerOpinions.vue?3b513be6